import naja from 'naja';
import scrollIntoView from 'scroll-into-view-if-needed';

export default class LazyComponent {
    private readonly element: Element;
    private readonly eventName: string | null;

    private loadingStarted: boolean = false;

    public constructor(element: Element, eventName: string | null = null) {
        this.element = element;
        this.eventName = eventName;

        if (eventName !== null) {
            element.addEventListener(eventName, this.loadContent.bind(this));
        } else {
            this.loadContent();
        }
    }

    private loadContent(): void {
        const url = this.element.getAttribute('data-url');

        if (this.loadingStarted || url === null || ! naja.uiHandler.isUrlAllowed(url)) {
            return;
        }

        naja.makeRequest('GET', url, null, { history: false, unique: false })
            .then(response => {
                if (this.eventName === null) {
                    return;
                }

                scrollIntoView(this.element, {
                    behavior: 'smooth',
                    scrollMode: 'if-needed',
                    block: 'nearest',
                    inline: 'nearest',
                });
            })
            .catch(() => this.loadingStarted = false);

        this.loadingStarted = true;
    }
}
